// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3Va_Z","select":"Header_select__3E762","clinic":"Header_clinic__38k6A"};